export default __webpack_public_path__ + "static/media/Train.8ba1432e.svg";